import React, { createContext, useState, useContext } from 'react';

const PrescriptionEditorContext = createContext();

export const PrescriptionEditorProvider = ({
  children,
  imageDates,
  initialDate,
  initialSurvey,
}) => {
  const initialMapState = {
    leftMap: {
      identifier: 'LEFT_MAP_IDENTIFIER',
      classificationsEnabled: false,
      variationsEnabled: true,
      sourceLayer: null,
      imageUrl: null,
      selectedDate: initialDate,
      multipleSelections: [],
      referenceValues: {},
      showClassificationDialog: false,
      mapSurvey: initialSurvey,
    },
    centerMap: {
      identifier: 'CENTER_MAP_IDENTIFIER',
      classificationsEnabled: false,
      variationsEnabled: true,
      sourceLayer: null,
      imageUrl: null,
      selectedDate: initialDate,
      multipleSelections: [],
      referenceValues: {},
      showClassificationDialog: false,
      mapSurvey: initialSurvey,
    },
  };

  const [mapsState, setMapsState] = useState(initialMapState);
  const [selectedMap, setSelectedMap] = useState('LEFT_MAP_IDENTIFIER');
  const datesWithImages = imageDates;
  const [mapPrescriptionBasedOn, setMapPrescriptionBasedOn] = useState('LEFT_MAP_IDENTIFIER');

  const updateMapsState = (updates) => {
    setMapsState((prev) => {
      let nextState = prev;

      Object.entries(updates).forEach(([mapName, mapUpdates]) => {
        const hasChanges = Object.entries(mapUpdates).some(
          ([key, value]) => !Object.is(prev[mapName][key], value)
        );
        if (hasChanges) {
          nextState = { ...nextState, [mapName]: { ...prev[mapName], ...mapUpdates } };
        }
      });

      return nextState;
    });
  };

  const updateMapState = (mapName, key, value) => {
    updateMapsState({ [mapName]: { [key]: value } });
  };

  return (
    <PrescriptionEditorContext.Provider
      value={{
        mapsState,
        updateMapState,
        updateMapsState,
        selectedMap,
        setSelectedMap,
        datesWithImages,
        mapPrescriptionBasedOn,
        setMapPrescriptionBasedOn,
      }}
    >
      {children}
    </PrescriptionEditorContext.Provider>
  );
};

export function usePrescriptionEditorContext() {
  const context = useContext(PrescriptionEditorContext);

  if (!context) {
    throw new Error(
      'usePrescriptionEditorContext must be used within a PrescriptionEditorProvider'
    );
  }

  return context;
}
